import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Conversation, ShortMessageStatus } from '../../../../models/inbox';
import {UserService} from '../../../services/user.service';
import {CommunicationService} from '../../../services/communication/communication.service';

@Component({
  selector: 'conversation-item',
  templateUrl: './conversation-item.component.html',
  styleUrls: ['./conversation-item.component.scss']
})
export class ConversationItemComponent {
  @Input()
  public conversation: Conversation;

  @Input()
  public editable = false;

  @Output()
  public removeConversation = new EventEmitter<Conversation>();

  @Output()
  public select = new EventEmitter<Conversation>();

  constructor(private communicationService: CommunicationService) { }

  public onDelete(e: Event) {
    this.removeConversation.emit(this.conversation);
  }

  public onSelect(e: Event) {
    this.select.emit(this.conversation);
  }

  public hasWarning(conversation: Conversation): boolean {
    return conversation.status === ShortMessageStatus.Warning;
  }

  public lastMessage(conversation) {
    return Array.isArray(conversation.messages) && conversation.messages.length > 0
      ? conversation.messages[conversation.messages.length - 1].content : null;
  }

  public getConversationName(con) {
    return this.communicationService.normalizeConversationName(con);
  }

  get canDelete() {
    return this.editable && !this.conversation.isHidden;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/conversation-item/conversation-item.component.ts